module.exports = __webpack_public_path__ + "static/img/jp_qxdsj.cc8aa52.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fajs/jp_qxdsj.png
// module id = 8Szi
// module chunks = 1